import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT
} from 'src/app/core/services/constant/constants.service';
import {
	AbstractControl,
	FormArray,
	FormBuilder,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators,
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { TypeStructure } from 'src/app/shared/models/typeStructure';
import { PrescripteurContact } from 'src/app/shared/models/prescripteurContact';

@Component({
	selector: 'app-prescripteur-form',
	templateUrl: './prescripteur-form.component.html',
	styleUrls: ['./prescripteur-form.component.scss']
})
export class PrescripteurFormComponent implements OnInit {
	/**
	 * Prescripteur
	 */
	@Input() prescripteur: Prescripteur;

	/**
	 * Vrai si formulaire d'ajout, faux sinon (formulaire de détail)
	 */
	@Input() isAddForm: boolean;

	/**
	 * Addresse sélectionner dans le typeahead
	 */
	@Input() isAddressSelected: { value: boolean };

	/**
	 * Booleen indiquant si il s'agit de l'addresse par défaut ou non
	 */
	@Input() isAddressDefault: { value: boolean };

	/**
	 * Formulaire angular
	 */
	@Input() form: FormGroup;

	/**
	 * Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	 */
	@Input() isValidateButtonClicked: { value: boolean };

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * Signal émis pour que la modal soit fermée
	 */
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	LABEL_BENEFICIAIRE: string;
	LABEL_INTERVENANT: string;
	MAX_NAME_CHAR = 25;

	/**
	 * Addresse selectionner
	 */
	selectedaddress?: Address;

	/**
	 * Typeahead des adresse en chargement
	 */
	typeaheadLoading?: boolean;

	/**
	 * Liste des adresse disponibles dans le typeahead
	 */
	addressList: Observable<NominatimResponse[]>;

	/**
	 * Liste des adresse récupérer grace au backend
	 */
	searchResults: NominatimResponse[];
	listTypeStructure: TypeStructure[];
	listContact: PrescripteurContact[];

	isPreferencesActive = false;
	isIntervenant: boolean;

	constructor(
		private facade: FacadeService,
		private logger: LogService,
		private fb: FormBuilder,
	) {
		this.addressList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.addressStructure);
		}).pipe(
			mergeMap((token: string) =>
				this.getNominatimDisplaynameAsObservable(token)
			)
		);
	}

	ngOnInit(): void {
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();
		if (this.prescripteur) {
			this.facade.typeStructureService.getAllTypeStructure().subscribe({
				next: (val) => {
					this.listTypeStructure = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
		}

		this.getAllEmployeesAndSetEmployeesInForm();
	}

	getAllEmployeesAndSetEmployeesInForm() {
		this.listContact = this.prescripteur.contacts != null ? [...this.prescripteur.contacts] : [];
		(this.form.get('contacts') as FormArray).removeAt(0);
		this.addressStructure?.setValidators([
			// Validators.required,
			// Validators.maxLength(60),
			this.isAddressValidValidator()
		]);
		this.facade.employeeService.getAllActiveEmployees().subscribe((data) => {
			if (!this.isAddForm) {
				if (this.prescripteur.addressStructure && this.prescripteur.addressStructure.label) {
					this.isAddressDefault.value = true;
				}

				console.log(this.listContact);
				for (let contact of this.listContact) {
					let id: FormControl = new FormControl('');
					let lastName: FormControl = new FormControl('');
					let firstName: FormControl = new FormControl('');
					let telephoneFixe: FormControl = new FormControl('');
					let telephonePortable: FormControl = new FormControl('');
					let telephoneStandard: FormControl = new FormControl('');
					let email: FormControl = new FormControl('', Validators.email);
					let fonction: FormControl = new FormControl('');
		
					id.setValue(contact.id);
					lastName.setValue(contact.lastName);
					firstName.setValue(contact.firstName);
					telephoneFixe.setValue(contact.telephoneFixe);
					telephonePortable.setValue(contact.telephonePortable);
					telephoneStandard.setValue(contact.telephoneStandard);
					email.setValue(contact.email);
					fonction.setValue(contact.fonction);
		
					(this.form.get('contacts') as FormArray).push(new FormGroup({
						id: id,
						lastName: lastName,
						firstName: firstName,
						telephoneFixe: telephoneFixe,
						telephonePortable: telephonePortable,
						telephoneStandard: telephoneStandard,
						email: email,
						fonction: fonction,
					}));
				}
				/**
				 * Récupère les données et initialise le formulaire
				 */
				this.form.patchValue({
					addressStructure: this.prescripteur.addressStructure.label || '',
					nomStructure: this.prescripteur.nomStructure,
					typeStructure: this.prescripteur.typeStructure?.id,
				});
			}
		});
	}

	/**
	 * Méthode appeler lors de la sélection d'un élément dans le typeahead
	 * @param event
	 */
	onAddressSelect(event: TypeaheadMatch) {
		this.isAddressDefault.value = false;
		this.isAddressSelected.value = true;
		this.selectedaddress = new Address();
		this.selectedaddress.label = event.item.displayName;
		this.selectedaddress.latitude = event.item.latitude;
		this.selectedaddress.longitude = event.item.longitude;
		this.form.controls['addressStructure'].updateValueAndValidity();
	}

	getNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.log(
					'' + err.status + ' ' + err.error.message ? err.error.message : ''
				);
			}
		});
		return of(this.searchResults);
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	/**
	 * Fonction appelée si une adresse commence à être tapée.
	 */
	selectedAddressKeyUp(e: any) {
		this.isAddressDefault.value = false;
		if (this.selectedaddress && this.selectedaddress.latitude != 0) {
			if (this.selectedaddress?.label === e.value) {
				this.isAddressSelected.value = true;
			}
		}else{
			this.selectedaddress = new Address();
			this.selectedaddress.label = e.value
			this.isAddressSelected.value = true;
		}
		this.form.controls['addressStructure'].updateValueAndValidity();
	}

	/**
	 * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
	 */
	submitForm() {
		if (this.form.valid) {
			this.prescripteur.nomStructure = this.form.value.nomStructure;
			if (this.isAddressSelected.value && this.selectedaddress !== null) {
				this.prescripteur.addressStructure = this.selectedaddress;
			} else {
				if (!this.isAddressDefault.value) {
					this.prescripteur.addressStructure.label = this.form.value.address;
				}
			}
			this.prescripteur.typeStructure = this.listTypeStructure.find(x => x.id == this.form.get('typeStructure').value); 
			this.prescripteur.contacts = this.form.value.contacts;
			if(!this.isIntervenant){
				this.prescripteur.region = this.facade.dataStorageService.getRegion();
			}
			this.sendForm.emit();
		}
	}

	get nomStructure() {
		return this.form.get('nomStructure');
	}
	get addressStructure() {
		return this.form?.get('addressStructure');
	}
	get typeStructure() {
		return this.form?.get('typeStructure');
	}
	get contactsPrescripteur() {
		return this.form.get('contacts') as FormArray;
	}

	onAddContact() {
		this.contactsPrescripteur.push(this.fb.group({
			id: '',
			lastName: '',
			firstName: '',
			telephoneFixe: '',
			telephonePortable: '',
			telephoneStandard: '',
			email: '',
			fonction: '',
		}));
	}
	
	removeContact(index:number)
	{
		(this.form.get('contacts') as FormArray).removeAt(index)
	}


	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

}
